{
  "screen": {
    "sectionHeading": "Dödsfall",
    "open": "Registrera dödsfall",
    "openCorrection": "Rätta dödsfallet",
    "heading": "Registrera dödsfall",
    "correctionHeading": "Rätta dödsfallet",
    "explanation": "Registrerar att patienten har avlidit. Du står som den läkare som konstaterade dödsfallet, och registreringen signeras i ditt namn. Vårdtillfället fortsätter och vårdplatsen är kvar tills patienten skrivs ut.",
    "correctionExplanation": "Rättelsen blir en ny version. Den tidigare finns kvar i journalen. Läkaren som konstaterade dödsfallet står kvar.",
    "requiredHint": "Fält utan anmärkning måste fyllas i.",
    "optional": "frivilligt",
    "final": "En registrering av dödsfall kan inte tas bort. Blev det fel, rätta den — eller dra tillbaka den om den gäller fel patient.",
    "save": "Registrera och signera",
    "saveCorrection": "Spara rättelsen och signera",
    "saving": "Sparar …",
    "cancel": "Avbryt",
    "close": "Stäng",
    "saved": "Dödsfallet är registrerat och signerat.",
    "savedCorrection": "Rättelsen är sparad och signerad.",
    "discardQuestion": "Stäng formuläret? Ingenting registreras.",
    "discardConfirm": "Stäng utan att spara",
    "discardCancel": "Fortsätt fylla i",
    "physicianOnly": "Bara en läkare kan registrera ett dödsfall, eftersom den som registrerar står som den som konstaterade det."
  },
  "field": {
    "diedAt": "Tidpunkt för dödsfallet",
    "estimated": "Tidpunkten är uppskattad — patienten anträffades avliden",
    "pronouncedAt": "Dödsfallet konstaterat",
    "police": "Anmält till polisen",
    "note": "Omständigheter",
    "withdraw": "Registreringen gäller fel patient eller är felaktig — dra tillbaka den"
  },
  "fieldHint": {
    "diedAt": "ÅÅÅÅ-MM-DD TT:MM med 24-timmarsklocka. Ändra om dödsfallet inträffade tidigare än nu.",
    "pronouncedAt": "När du konstaterade dödsfallet, ÅÅÅÅ-MM-DD TT:MM. Inte före tidpunkten för dödsfallet.",
    "police": "Polisen beslutar om rättsmedicinsk undersökning. Välj ett svar — det finns inget förval.",
    "note": "Hur och var patienten anträffades, vem som var närvarande. Skriv inte dödsorsak här — den hör till dödsorsaksintyget."
  },
  "police": {
    "notified": "Ja, anmält till polisen",
    "not-notified": "Nej, inte anmält",
    "not-assessed": "Inte bedömt ännu"
  },
  "banner": {
    "died": "Avliden {diedAt}",
    "diedEstimated": "Avliden omkring {diedAt} (uppskattad tid)",
    "pronounced": "Konstaterat {pronouncedAt} av {name}",
    "police": "Polisanmälan: {answer}"
  },
  "refusal": {
    "timeMissing": "Fyll i fältet ”{field}”. Ingenting registrerades.",
    "timeMalformed": "”{field}” läses inte som en tidpunkt. Skriv den som ÅÅÅÅ-MM-DD TT:MM, till exempel 2026-10-15 08:00. Ingenting registrerades.",
    "timeInFuture": "”{field}” ligger i framtiden. Ingenting registrerades.",
    "pronouncedBeforeDeath": "Dödsfallet kan inte ha konstaterats innan det inträffade. Kontrollera de två tiderna. Ingenting registrerades.",
    "policeMissing": "Välj om dödsfallet är anmält till polisen. Ingenting registrerades.",
    "fieldTooLong": "Omständigheterna är för långa. Korta ner till högst {max} tecken. Ingenting registrerades.",
    "alreadyRecorded": "Ett dödsfall är redan registrerat för patienten. Översikten är uppdaterad — rätta det i stället. Ingenting registrerades.",
    "noChange": "Rättelsen ändrar ingenting. Ingenting sparades.",
    "stale": "Någon annan har ändrat registreringen medan formuläret var öppet. Översikten är uppdaterad — kontrollera och försök igen. Ingenting sparades.",
    "retracted": "Registreringen är redan tillbakadragen och kan inte rättas.",
    "notFound": "Registreringen finns inte i journalen. Öppna patientöversikten igen.",
    "patientNotFound": "Patienten finns inte i journalen. Ingenting registrerades.",
    "roleMayNotEstablishDeath": "Bara en läkare kan registrera ett dödsfall. Ingenting registrerades.",
    "unknown": "Ingenting registrerades. Försök igen.",
    "unavailable": "Ingen kontakt med servern. Det är inte säkert om registreringen sparades — öppna patientöversikten igen och kontrollera innan du försöker igen."
  }
}
